import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";
import styled from "styled-components";
import useFetch from "../../server/useFetch";
import { websocketPort } from "../../server/websocketPort";
import Theme from '../../styles/Theme/Theme';
import Spinner from "../Global/Atomics/Spinner";
import { Text } from "../Global/Atomics/Text";
import { WidgetCard } from "../Global/Atomics/WidgetCard";
import CustomIcon from "../Global/Icons/CustomIcon";
import query from "../../server/constants.api";

const GridColumn = styled.div`
    grid-column: ${props => (props.gridColumn ? props.gridColumn : null)};
    grid-row: ${props => (props.gridRow ? props.gridRow : null)};
`;

const socket = io(websocketPort);
export const OperationStatusWidget = () => {
    const structureOrder = ["Car", "Transports", "PublicSpace", "Trash", "Parking", "Lamp", "Medical", "Bolt", "WaterDrop", "Environment"];

    // Dummy data for testing
    const dummyData = [
        { value: 12, icon: "Car", mrt: "2d 4h", availability: 95, current: { state: 1, tendency: 0 }, forecast: { state: 2, tendency: 1 } },
        { value: 8, icon: "Transports", mrt: "1d 2h", availability: 98, current: { state: 2, tendency: 0 }, forecast: { state: 2, tendency: 0 } },
        { value: 15, icon: "PublicSpace", mrt: "3d 6h", availability: 92, current: { state: 1, tendency: 0 }, forecast: { state: 1, tendency: 2 } },
        { value: 5, icon: "Trash", mrt: "1d 0h", availability: 99, current: { state: 2, tendency: 0 }, forecast: { state: 2, tendency: 0 } },
        { value: 20, icon: "Parking", mrt: "4d 8h", availability: 88, current: { state: 1, tendency: 0 }, forecast: { state: 2, tendency: 2 } },
        { value: 10, icon: "Lamp", mrt: "2d 2h", availability: 96, current: { state: 2, tendency: 0 }, forecast: { state: 2, tendency: 0 } },
        { value: 3, icon: "Medical", mrt: "0d 12h", availability: 100, current: { state: 2, tendency: 0 }, forecast: { state: 2, tendency: 0 } },
        { value: 7, icon: "Bolt", mrt: "1d 6h", availability: 97, current: { state: 2, tendency: 0 }, forecast: { state: 1, tendency: 1 } },
        { value: 6, icon: "WaterDrop", mrt: "1d 4h", availability: 98, current: { state: 2, tendency: 0 }, forecast: { state: 2, tendency: 0 } },
        { value: 9, icon: "Environment", mrt: "2d 0h", availability: 94, current: { state: 1, tendency: 0 }, forecast: { state: 2, tendency: 2 } }
    ];

    const { data: operationStatusData, isFetching: operationStatusIsFetching, refetch: refetchOperationStatus } = useFetch('/videowall/operations/status', 'getOperationStatus', {
        tenant: 'TOP/CASCAIS/CM CASCAIS'
    }, 60000, query.middlewareCommandURL);
    const [operationStatus, setOperationsStatus] = useState(null);

    useEffect(() => {
        // Use dummy data if no real data is available
        const dataToUse = operationStatusData || null;
        if (dataToUse) {
            setOperationsStatus(getOperationStatusStructure(dataToUse, structureOrder));
        } else {
            // Set dummy data directly
            setOperationsStatus(dummyData);
        }
    }, [operationStatusData])

    useEffect(() => {
        socket.on("manageIncident", (text) => {
            console.log("Refetch Operation Status");
            refetchOperationStatus();
        });
    }, [])

    return (
        <>
            {operationStatus ?
                <WidgetCard display='grid' padding='8px' margin='0' style={{ width: '100%', height: '100%', gridTemplateColumns: `1.5fr repeat(${structureOrder.length}, 1fr)`, gridTemplateRows: '0.8fr 0.5fr 0.5fr 0.5fr', gridAutFlow: 'column', boxSizing: 'border-box', overflow: 'hidden', minWidth: 0 }}>
                    {/* {operatioStatusData && operatioStatusData.length ? */}
                    <>
                        <FirstColumn />
                        {operationStatus.map((val, key) => {
                            return (<NextColumn key={key} props={val} gridColumn={key + 2}
                                borderTopRightRadius={operationStatus.length - 1 === key ? '12px' : null}
                                borderBottomRightRadius={operationStatus.length - 1 === key ? '12px' : null} />)
                        })}
                    </>
                    {/* // : <div style={{ height: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        //     <NoData />
                        // </div>
                    // } */}
                </WidgetCard>
                : <div style={{ height: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}><Spinner stroke="green" /></div>
            }
        </>
    )
}

const FirstColumn = () => {
    return (
        <>
            <GridColumn gridColumn='1' gridRow='1 / 2' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderBottom: '1px ridge gray' }}>
                <div style={{ display: 'flex', alignItems: 'center', alignSelf: 'flex-start' }}>
                    <CustomIcon icon={'Clipboard'} iconSize='sm' color={Theme.color['teal-4']} />
                    <Text color={Theme.color['coolgray-12']} marginLeft='0.4vw' fontSize='text_lg' fontWeight={Theme.typography.weight.medium}>Operation Status</Text>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <Text color={Theme.color['coolgray-12']} margin='0' fontSize='text_md' fontWeight={Theme.typography.weight.medium} marginLeft='20px'>Incidents</Text>
                    <Text color={Theme.color['coolgray-10']} margin='0' fontSize='text_md'>P1 & P2</Text>
                </div>
            </GridColumn>
            <GridColumn gridColumn='1' gridRow='2 / 3' style={{ display: 'flex', placeItems: 'center', justifyContent: 'flex-end', overflow: 'hidden' }}>
                <Text color={Theme.color['coolgray-10']} margin='0' fontSize='text_md' style={{ whiteSpace: 'nowrap' }}>MRT | Availability</Text>
            </GridColumn>
            <GridColumn gridColumn='1' gridRow='3 / 4' style={{ display: 'flex', placeItems: 'center', justifyContent: 'space-between' }}>
                <Text color={Theme.color['coolgray-12']} margin='0' fontSize='text_md' fontWeight={Theme.typography.weight.medium} marginLeft='20px'>Service Quality</Text>
                <div style={{ backgroundColor: '#F2F6F7', height: '-webkit-fill-available', display: 'flex', alignItems: 'center', paddingLeft: '20px', borderTopLeftRadius: '12px', borderBottomLeftRadius: '12px' }}><Text color='#0076A8' margin='0' fontSize='text_md' fontWeight={Theme.typography.weight.bold}>Current</Text></div>
            </GridColumn>
            <GridColumn gridColumn='1' gridRow='4 / 5' style={{ display: 'flex', placeItems: 'center', justifyContent: 'flex-end' }}>
                <Text color={Theme.color['coolgray-12']} margin='0' fontSize='text_md'>Next Hour</Text>
            </GridColumn>
        </>
    )
};

const NextColumn = (props) => {
    return (
        <>
            <GridColumn gridColumn={props.gridColumn} gridRow='1 / 2' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px ridge gray' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5vh' }}>
                    <CustomIcon icon={props?.props?.icon} iconSize='lg' BgColor={Theme.color['blue-4']} />
                </div>
                <Text color={Theme.color['black-1']} marginBottom='10px' fontSize='text_lg' fontWeight={Theme.typography.weight.medium}>{props?.props?.value}</Text>
            </GridColumn>
            <GridColumn gridColumn={props.gridColumn} gridRow='2 / 3' style={{ display: 'flex', placeItems: 'center', justifyContent: 'center', overflow: 'hidden', minWidth: 0 }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', overflow: 'hidden', minWidth: 0, width: '100%' }}>
                    <Text color={Theme.color['coolgray-10']} margin='0' fontSize='text_md' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>{props?.props?.mrt}</Text>
                    <Text color={Theme.color['coolgray-12']} margin='0' fontSize='text_md' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>{props?.props?.availability}%</Text>
                </div>
            </GridColumn>
            <GridColumn gridColumn={props.gridColumn} gridRow='3 / 4' style={{ display: 'flex', placeItems: 'center', justifyContent: 'center', position: 'relative', backgroundColor: '#F2F6F7', padding: '10px', borderTopRightRadius: props.borderTopRightRadius, borderBottomRightRadius: props.borderBottomRightRadius }}>
                {props?.props?.current?.tendency !== 0 && (
                    <div style={{ position: 'absolute', left: '4px', display: 'flex' }}>
                        <CustomIcon iconSize='xs'
                            icon={checkTendency(props?.props?.current?.tendency)}
                            color={props?.props?.current?.tendency === 1 ? Theme.color['error-4'] : Theme.color['success-4']}
                            BgColor={props?.props?.current?.tendency === 1 ? Theme.color['error-1'] : Theme.color['success-1']} />
                    </div>
                )}
                <div style={{ display: 'flex', visibility: props?.props?.current?.state === 0 ? 'hidden' : null }}>
                    <CustomIcon icon={'QualityCircle'} color={checkState(props?.props?.current?.state)} iconSize='md' />
                </div>
            </GridColumn>
            <GridColumn gridColumn={props.gridColumn} gridRow='4 / 5' style={{ display: 'flex', placeItems: 'center', justifyContent: 'center', position: 'relative' }}>
                {props?.props?.forecast?.tendency !== 0 && (
                    <div style={{ position: 'absolute', left: '4px', display: 'flex' }}>
                        <CustomIcon iconSize='xs'
                            icon={checkTendency(props?.props?.forecast?.tendency)}
                            color={props?.props?.forecast?.tendency === 1 ? Theme.color['error-4'] : Theme.color['success-4']}
                            BgColor={props?.props?.forecast?.tendency === 1 ? Theme.color['error-1'] : Theme.color['success-1']} />
                    </div>
                )}
                <div style={{ display: 'flex', visibility: props?.props?.forecast?.state === 0 ? 'hidden' : null }}>
                    <CustomIcon icon={'QualityCircle'} color={checkState(props?.props?.forecast?.state)} iconSize='md' />
                </div>
            </GridColumn>
        </>
    )
}

function checkState(value) {
    switch (value) {
        case 1:
            return Theme.color['critical-base']
        case 2:
            return Theme.color['high-base']
        // case 3:
        //     return Theme.color['medium-base']
        // case 4:
        //     return Theme.color['low-base']
        // case 5:
        //     return Theme.color['coolgray-6']
        default:
            return Theme.color['white'];
    }
}

function checkTendency(value) {
    if (value === 1) {
        return 'QualityBad'
    } else {
        return 'QualityGood'
    }
}

function getOperationStatusStructure(data, structureOrder) {
    if (!data) return null;

    const result = [];
    structureOrder.map((icon) => {
        if (icon === 'Car') {
            const familiesResults = getObjectOperationStatus(data, ['Mobility.Parking'], icon);
            result.push(familiesResults);
        }
        if (icon === 'Transports') {
            const familiesResults = getObjectOperationStatus(data, ['Mobility.Transportation'], icon);
            result.push(familiesResults);
        }
        if (icon === 'PublicSpace') {
            const familiesResults = getObjectOperationStatus(data, ['Living.Public Space', 'Government and Education.Administration'], icon);
            result.push(familiesResults);
        }
        if (icon === 'Trash') {
            const familiesResults = getObjectOperationStatus(data, ['Energy and Environment.Waste Water', 'Energy And Environment.Solid Waste'], icon);
            result.push(familiesResults);
        }
        if (icon === 'Parking') {
            const familiesResults = getObjectOperationStatus(data, ['Mobility.Parking'], icon);
            result.push(familiesResults);
        }
        if (icon === 'Lamp') {
            const familiesResults = getObjectOperationStatus(data, ['Living.Illumination'], icon);
            result.push(familiesResults);
        }
        if (icon === 'Medical') {
            const familiesResults = getObjectOperationStatus(data, ['People.Safety', 'People.Emergency'], icon);
            result.push(familiesResults);
        }
        if (icon === 'Bolt') {
            const familiesResults = getObjectOperationStatus(data, ['Energy and Environment.Energy'], icon);
            result.push(familiesResults);
        }
        if (icon === 'WaterDrop') {
            const familiesResults = getObjectOperationStatus(data, ['Energy and Environment.Water'], icon);
            result.push(familiesResults);
        }
        if (icon === 'Environment') {
            const familiesResults = getObjectOperationStatus(data, ['Energy and Environment.Climate', 'Energy and Environment.Pollution', 'Energy and Environment.Fauna Flora'], icon);
            result.push(familiesResults);
        }
    });

    return result;
};

function getObjectOperationStatus(data, families, icon) {
    const result = [];
    families.map((family) => {
        const familyObject = data.find((el) => el.family === family);
        if (familyObject) {
            result.push({
                value: (familyObject.value || 0),
                mrt: (familyObject.mrt || 0),
                availability: (familyObject.availability || 0),
                "current": {
                    "state": Math.max(familyObject.current || 0),
                    "tendency": 0
                }
            });
        }
    });

    const parseMRT = (mrt) => {
        const [days, hours] = mrt.split(' ').map(part => parseInt(part.replace(/\D/g, ''), 10));
        return (days * 24) + hours; // Convert days to hours and add the hours
    };

    return {
        value: result.reduce((acc, family) => acc + (family.value || 0), 0),
        icon: icon,
        mrt: result.reduce((max, family) => {
            const familyMRT = parseMRT(family.mrt || "0d 0h");
            return familyMRT > parseMRT(max) ? family.mrt : max;
        }, "0d 0h"),
        availability: result.reduce((acc, family) => acc + (family.availability || 0), 0),
        "current": {
            "state": Math.max(...result.map(family => family.current.state || 0)),
            "tendency": 0
        }
    };
};

// const familiesOperationStatusStructure = [
//     {
//         "value": 10,
//         "icon": "Car",
//         "mrt": "7d 0H",
//         "availability": 0,
//         "current": {
//             "state": 1,
//             "tendency": 0
//         },
//         "forecast": {
//             "state": 0,
//             "tendency": 0
//         }
//     },
//     {
//         "value": 3,
//         "icon": "Transports",
//         "mrt": "7d 0H",
//         "availability": 0,
//         "current": {
//             "state": 2,
//             "tendency": 0
//         },
//         "forecast": {
//             "state": 0,
//             "tendency": 0
//         }
//     },
//     {
//         "value": 0,
//         "icon": "PublicSpace",
//         "mrt": "0d 0h",
//         "availability": "100",
//         "current": {
//             "state": 3,
//             "tendency": 0
//         },
//         "forecast": {
//             "state": 0,
//             "tendency": 0
//         }
//     },
//     {
//         "value": 4,
//         "icon": "Trash",
//         "mrt": "7d 0H",
//         "availability": 0,
//         "current": {
//             "state": 2,
//             "tendency": 0
//         },
//         "forecast": {
//             "state": 0,
//             "tendency": 0
//         }
//     },
//     {
//         "value": 3,
//         "icon": "Parking",
//         "mrt": "7d 0H",
//         "availability": 0,
//         "current": {
//             "state": 2,
//             "tendency": 0
//         },
//         "forecast": {
//             "state": 0,
//             "tendency": 0
//         }
//     },
//     {
//         "value": 1,
//         "icon": "Lamp",
//         "mrt": "7d 0H",
//         "availability": 0,
//         "current": {
//             "state": 1,
//             "tendency": 0
//         },
//         "forecast": {
//             "state": 0,
//             "tendency": 0
//         }
//     },
//     {
//         "value": 0,
//         "icon": "Medical",
//         "mrt": "0d 0h",
//         "availability": "100",
//         "current": {
//             "state": 3,
//             "tendency": 0
//         },
//         "forecast": {
//             "state": 0,
//             "tendency": 0
//         }
//     },
//     {
//         "value": 25,
//         "icon": "Bolt",
//         "mrt": "7d 0H",
//         "availability": 0,
//         "current": {
//             "state": 1,
//             "tendency": 0
//         },
//         "forecast": {
//             "state": 0,
//             "tendency": 0
//         }
//     },
//     {
//         "value": 9,
//         "icon": "WaterDrop",
//         "mrt": "7d 0H",
//         "availability": 0,
//         "current": {
//             "state": 2,
//             "tendency": 0
//         },
//         "forecast": {
//             "state": 0,
//             "tendency": 0
//         }
//     },
//     {
//         "value": 7,
//         "icon": "Environment",
//         "mrt": "7d 0H",
//         "availability": 0,
//         "current": {
//             "state": 2,
//             "tendency": 0
//         },
//         "forecast": {
//             "state": 0,
//             "tendency": 0
//         }
//     }
// ];